<template>
  <div class="c-aed-pendingMove">
    <div
      class="c-aed-pendingMove__message o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-start o-grid--wrap-nowrap"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--grow-0">
          <svg
            class="o-svg-icon o-button__icon"
            viewBox="0 0 64 64"
            type="image/svg+xml"
          >
            <use
              xlink:href="spritemap.svg#sprite-field-error"
              x="0"
              y="0"
            ></use>
          </svg>
        </div>
        <div class="o-grid__item o-grid__item--grow-0">
          <div>
            {{ pendingMoveTranslations.message }}
            {{ pendingFadder.date | formatDate("DD MMMM YYYY") }}.
          </div>
          <div>{{ pendingMoveTranslations.awaitingApproval }}</div>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-start o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="customTranslations.firstName || ''">{{
            customTranslations.firstName || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="FirstName"
            :canEdit="false"
            :value="pendingFadder.firstName || ' '"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-start o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="customTranslations.lastName || ''">{{
            customTranslations.lastName || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="LastName"
            :canEdit="false"
            :value="pendingFadder.lastName || ' '"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-start o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="customTranslations.email || ''">{{
            customTranslations.email || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="Email"
            :canEdit="false"
            :value="pendingFadder.email || ' '"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div class="o-grid__item c-pending-move__buttons">
      <button
        class="o-button o-button--secondary c-pending-move__button"
        @click="tableModal.showOwnerChangeCancel = true"
      >
        {{ pendingMoveTranslations.cancelChangeOfOwner || "" }}
      </button>
      <button
        class="o-button o-button--secondary c-pending-move__button"
        @click="triggerResendConfirmationEmail"
      >
        {{ pendingMoveTranslations.resendConfirmationEmail || "" }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "c-aed-pendingMove",
  data() {
    return {
      section: "pendingFadder",
      name: "",
      tableModal: null,
      test: null
    };
  },
  methods: {
    ...mapActions("owners", ["resendConfirmationEmail"]),
    triggerResendConfirmationEmail() {
      const response = this.resendConfirmationEmail({
        profileId: this.pendingFadder.id
      });

      response.then(() => {
        this.tableModal.showResendConfirmationModal = true;
      });
    }
  },
  mounted() {
    this.tableModal = this.$parent.$parent;
  },
  computed: {
    ...mapState("translations", {
      pendingMoveTranslations: "pendingMove",
      customTranslations: "custom"
    }),
    ...mapGetters("aed", ["pendingFadder"]),
    ...mapState("aeds", ["parameters"])
  }
};
</script>
<style lang="scss">
.c-aed-pendingMove {
  &__message {
    border-top: 1px solid $s-cp-neutral-600;
    padding: 20px 0;
    font-style: italic;
  }
}

.c-pending-move__buttons {
  display: flex;
  margin-top: 20px;
}

.c-pending-move__button:first-child {
  margin-right: 12px;
}
</style>
